<!-- Button trigger modal -->
<div style="text-align: center; margin-top: 10px;">
    <button *ngIf="contractData && role == 'admin'" [disabled]="contractData.isCompleted" type="button" class="btn btn-warning" data-toggle="modal" aria-label="Left Align" data-target="#completedContractModal">
        <span *ngIf="!contractData.isCompleted">
            Marcar contrato completado
        </span>
        <span *ngIf="contractData.isCompleted">
            Contrato Completado
        </span>
        
    </button>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="completedContractModal" tabindex="-1" role="dialog" aria-labelledby="completedContractModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="completedContractModalLabel">Marcar contrato completado</h5>
                <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="contractData">
                <p>Está seleccionando marcar el contrato #<strong>{{ contractData.id }}</strong> como completado.</p>
                <p>Para confirmar esto, seleccione "marcar completado".</p>
            </div>
            <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
                Error intente luego...
            </div>
            <div class="modal-footer">
            
                <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" (click)="completeContract()" class="btn btn-success">Marcar Completado</button>
            </div>
       
        </div>
    </div>
    </div>